/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  GetActivitiesForOrgParams,
  GetUserParams,
  InfiniteScrollUserActivity,
  UserActivity,
  UserActivityCreationDto,
  UserActivityExists,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class UserActivityController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * @description For InfiniteScrolling the from field should be replaced with the last element returned from the query 'now' or null is fine for the first page
   *
   * @tags user-activity-controller
   * @name GetUser
   * @summary Get user activities for orgId and userId
   * @request GET:/api/v1/organisation/{organisationId}/user/{userId}/activity
   */
  getUser = ({ organisationId, userId, ...query }: GetUserParams, params: RequestParams = {}) =>
    this.http.request<InfiniteScrollUserActivity, any>({
      path: `/v1/organisation/${organisationId}/user/${userId}/activity`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getUserPath = '/v1/organisation/${organisationId}/user/${userId}/activity'
  static getUserMethod = 'GET'
  /**
   * No description
   *
   * @tags user-activity-controller
   * @name CreateActivity
   * @request POST:/api/v1/organisation/{organisationId}/user/{userId}/activity
   */
  createActivity = (
    organisationId: string,
    userId: string,
    data: UserActivityCreationDto,
    params: RequestParams = {},
  ) =>
    this.http.request<UserActivity, any>({
      path: `/v1/organisation/${organisationId}/user/${userId}/activity`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createActivityPath = '/v1/organisation/${organisationId}/user/${userId}/activity'
  static createActivityMethod = 'POST'
  /**
   * No description
   *
   * @tags user-activity-controller
   * @name GetUserActivityById
   * @request GET:/api/v1/organisation/{organisationId}/user/{userId}/activity/{activityName}
   */
  getUserActivityById = (
    organisationId: string,
    userId: string,
    activityName: string,
    params: RequestParams = {},
  ) =>
    this.http.request<UserActivity, any>({
      path: `/v1/organisation/${organisationId}/user/${userId}/activity/${activityName}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getUserActivityByIdPath =
    '/v1/organisation/${organisationId}/user/${userId}/activity/${activityName}'
  static getUserActivityByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags user-activity-controller
   * @name UserActivityExistsById
   * @request GET:/api/v1/organisation/{organisationId}/user/{userId}/activity/{activityName}/exists
   */
  userActivityExistsById = (
    organisationId: string,
    userId: string,
    activityName: string,
    params: RequestParams = {},
  ) =>
    this.http.request<UserActivityExists, any>({
      path: `/v1/organisation/${organisationId}/user/${userId}/activity/${activityName}/exists`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static userActivityExistsByIdPath =
    '/v1/organisation/${organisationId}/user/${userId}/activity/${activityName}/exists'
  static userActivityExistsByIdMethod = 'GET'
  /**
   * @description For InfiniteScrolling the from field should be replaced with the last element returned from the query 'now' or null is fine for the first page Default sorting is by createTime, descending
   *
   * @tags user-activity-controller
   * @name GetActivitiesForOrg
   * @summary Get user activities for orgId
   * @request GET:/api/v1/organisation/{organisationId}/activity
   */
  getActivitiesForOrg = (
    { organisationId, ...query }: GetActivitiesForOrgParams,
    params: RequestParams = {},
  ) =>
    this.http.request<InfiniteScrollUserActivity, any>({
      path: `/v1/organisation/${organisationId}/activity`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getActivitiesForOrgPath = '/v1/organisation/${organisationId}/activity'
  static getActivitiesForOrgMethod = 'GET'
}
